<script>
import appConfig from "../../../app.config";
import axios from 'axios';
import DataTable from 'datatables.net-vue3';
import moment from 'moment';
import { usePermissions } from '@/composables/usePermissions';

export default {
    page: {
        title: "Orders",
        meta: [{ name: "description", content: appConfig.description }],
    },
    props: {
        customerid :{
            type : Number,
        }
    },
    data(){
        return {
            customer_order_info:[],
            loadingDetail:false,
            loadingRoles:true,
            ButtonSeen:true,
        };  
    },
  setup() {
        const {
            canReadCustomers,
            canCreateCustomers,
            canUpdateCustomers,
            canReadOrder,
            arPermissions
        } = usePermissions()
        return {
            canReadCustomers,
            canCreateCustomers,
            canUpdateCustomers,
            canReadOrder,
            arPermissions
        };
    },
    methods: {
        format_date(value){
            if (value) {
                return moment(String(value)).format('DD-MM-YYYY')
            }
        },

        get_customer_order_by_id(){
        axios.defaults.headers.common['authorization'] = 'Bearer ' + localStorage.getItem('jwt')
        axios.get(process.env.VUE_APP_API_BASEURL+'customer/order_details/'+this.customerid)
        .then(response => {
            if (response) {
                this.loadingRoles=false;
                this.customer_order_info = response.data;
                console.log(this.customer_order_info);
            } 
            else {
                this.messageBag = ['No record.'];
            }
        })
        .catch(error => {
            this.messageBag = [error.error];
        });
    }, 
    },

    components: {
        DataTable,
    },

    mounted() {
        this.get_customer_order_by_id();     
    },
};
require("@/assets/css/datatable.css");
</script>

<template>
  <div class="card card-height-100" v-if="canReadOrder">
    <div class="card-body p-0">
      <div>
        <div v-if='loadingRoles'>
              <div class="spinner-border text-success" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
          </div>
          <div v-else>
            <div class="table-responsive">
                <DataTable :options="{lengthChange: false}" class="table table-striped table-nowrap mb-0"> 
                    <thead class="table-secondary">
                        <tr>
                            <th>#.</th>
                            <th scope="col">Order Number</th>           
                            <th scope="col">Order Date</th>           
                            <th scope="col">Customer Name</th>           
                            <th scope="col">Data Verification</th>           
                            <th scope="col">Call Verification</th>                                                      
                            <th scope="col">Program</th>
                            <th scope="col">Device Name</th>
                            <th scope="col">SKU</th>
                            <th scope="col">Price</th>
                            <th scope="col">Status</th>
                            <!--th scope="col">Created On</th-->
                        </tr>
                    </thead>
                    <tbody>                                
                        <tr v-for="(item, index) in customer_order_info" :key="index" class="content">
                            <td>{{ index+1 }}</td>
                            <td><router-link :to="'/orders/customer-order-details/'+this.customerid" class="fw-medium link-secondary">{{ item.orderId }}</router-link></td>                               
                            <!--td>{{ item.orderId }}</td-->
                            <td>{{ format_date(item.created_at) }}</td>
                            <td>{{ item.name_as_per_nric }}</td>
                            <td v-if="item.data_verification == 1"><span class="badge bg-success">YES</span></td>
                            <td v-else-if="item.data_verification == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else><span class="badge bg-secondary">NO</span></td>
                            <td v-if="item.call_verification == 1"><span class="badge bg-success">YES</span></td>
                            <td v-else-if="item.call_verification == 2"><span class="badge bg-danger">FAILED</span></td>
                            <td v-else><span class="badge bg-secondary">NO</span></td>
                            <td>{{ item.program_name }}</td>
                            <td>{{ item.product_name }}</td>                                          
                            <td>{{ item.sku }}</td>                                          
                            <td>RM {{ item.price }}</td>                                          
                            <td>{{ item.order_status_name }}</td>                                          
                        </tr>
                    </tbody>
                </DataTable>
            </div>
        </div>
      </div>
    </div>
  </div>


    <div v-else class="text-center text-muted p-4">
            You do not have permission to view Orders.
     </div>
</template>
